// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"Avatar_profileImage__2sMav","clicked":"Avatar_clicked__1-4ng"};